import { z } from 'zod'
export const categorySchema = z.object({
  id: z.string(),
  parentId: z.string(),
  name: z.string(),
  sort: z.number(),
  imageUrl: z.string(),
  isVisible: z.boolean(),
})
export const categoryDetailSchema = categorySchema.extend({
  subCategories: categorySchema.array(),
})
export const categoryListSchema = z.object({
  totalCount: z.number(),
  results: categorySchema.array(),
})

export type Category = z.infer<typeof categorySchema>
export type CategoryDetail = z.infer<typeof categoryDetailSchema>
export type CategoryList = z.infer<typeof categoryListSchema>
